/** API status → English label (same tone as Sign in / Add To Cart). */
export const DASHBOARD_STATUS_LABELS = {
	ordered: 'Already ordered',
	not_ordered: 'No order yet',
	cancelled: 'Cancelled',
	inactive: 'Inactive',
};

export function dashboardStatusLabel(status) {
	return DASHBOARD_STATUS_LABELS[status] || status || 'No order yet';
}

export function canOrderForChild(child) {
	if (!child) return false;
	if (child.is_active === false) return false;
	if (child.family_is_active === false) return false;
	if (child.status === 'inactive') return false;
	return true;
}

/** BE may send a JSON array; ignore non-arrays (legacy string payloads). */
export function normalizeServingTimes(raw) {
	if (Array.isArray(raw)) return raw;
	return [];
}

/**
 * Lines to show on a child card.
 * - Meal sessions (Lunch/Snack/…): only when quantity > 0, or legacy `is_void`.
 * - Special BE bucket `Void`: voided order-product count — only when quantity > 0.
 */
export function visibleServingTimeLines(raw) {
	return normalizeServingTimes(raw).filter((st) => {
		if (!st || st.name == null || st.name === '') return false;
		const qty = Number(st.quantity) || 0;
		const isVoidBucket = String(st.name).toLowerCase() === 'void';
		if (isVoidBucket) return qty > 0;
		if (st.is_void) return true;
		return qty > 0;
	});
}

/** English label for one serving_times row (Void bucket → "Voided N"). */
export function servingTimeDisplayLabel(st) {
	const name = String(st?.name ?? '');
	const qty = st?.quantity ?? 0;
	if (name.toLowerCase() === 'void') {
		return `Voided ${qty}`;
	}
	let label = `${name} ${qty}`;
	if (st?.is_void) label += ' (void)';
	return label;
}
